var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 5,
    height: 5,
    rx: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 5,
    height: 5,
    rx: 0.5,
    stroke: "#FEC168",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 4.5,
    width: 5,
    height: 5,
    rx: 0.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 4.5,
    width: 5,
    height: 5,
    rx: 0.5,
    stroke: "#FEC168",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    mask: "url(#path-2-inside-2)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 10.5,
    width: 5,
    height: 5,
    rx: 0.5
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 10.5,
    width: 5,
    height: 5,
    rx: 0.5,
    stroke: "#FEC168",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    mask: "url(#path-3-inside-3)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 10.5,
    width: 5,
    height: 5,
    rx: 0.5
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 10.5,
    width: 5,
    height: 5,
    rx: 0.5,
    fill: "#FEC168",
    stroke: "#FEC168",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    mask: "url(#path-4-inside-4)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H6.5",
    stroke: "#FEC168",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3V6.5",
    stroke: "#FEC168",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17L3 13.5",
    stroke: "#FEC168",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17H6.5",
    stroke: "#FEC168",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17H13.5",
    stroke: "#FEC168",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17V13.5",
    stroke: "#FEC168",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3V6.5",
    stroke: "#FEC168",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3L13.5 3",
    stroke: "#FEC168",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.89ebca523df9d062c9dc2bc475d2e140.svg";
export { ForwardRef as ReactComponent };